import React from 'react'
import styled from '@emotion/styled'
import { Stack, Flex, theme } from '@mindfulchefuk/design-system'
import { RecipeWithQuantity } from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeCardWithClaimsTitle } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardWithClaimsTitle/RecipeCardWithClaimsTitle'
import { RecipeCardWithClaimsStats } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardWithClaimsStats/RecipeCardWithClaimsStats'
import { RecipeActionButtons } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeActionButtons/RecipeActionButtons'

type TRecipeCardWithClaimsFooter = {
  isBasketFull: boolean
  isWithinOrderWindow: boolean
  onAddRecipe: () => void
  onSubtractRecipe: () => void
  recipe: RecipeWithQuantity
  showPrice: boolean
}

const FlexWithGap = styled(Flex)`
  gap: ${theme.space[8]};
`

export const RecipeCardWithClaimsFooter = ({
  isBasketFull,
  isWithinOrderWindow,
  onAddRecipe,
  onSubtractRecipe,
  recipe,
  showPrice,
}: TRecipeCardWithClaimsFooter) => {
  const { quantity, spicinessLevel, title } = recipe

  return (
    <Stack p={16} spacing={16} position="relative" height="100%" width="100%">
      <RecipeCardWithClaimsTitle
        title={title}
        spicinessLevel={spicinessLevel}
      />

      <FlexWithGap
        justifyContent="space-between"
        alignItems="flex-end"
        height="100%"
        width="100%"
      >
        <RecipeCardWithClaimsStats recipe={recipe} showPrice={showPrice} />
        {isWithinOrderWindow && (
          <RecipeActionButtons
            isBasketFull={isBasketFull}
            onAddRecipe={onAddRecipe}
            onSubtractRecipe={onSubtractRecipe}
            quantityInBasket={quantity}
            recipeTitle={title}
            isModal={false}
          />
        )}
      </FlexWithGap>
    </Stack>
  )
}
